@if(userType === 'LeapMotor'){
<mat-form-field class="{{displayClass}}">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  @if(iconClass){
    <nuc-icon [iconClass]="iconClass" size="32" [displayClass]="displayIconClass"></nuc-icon>
  }
  <mat-select
    [formControl]="formControl"
    (selectionChange)="onSelectionChange($event)"
    [disabled]="isDisabled"
    [compareWith]="compareWith"
    [panelClass]="'language-switcher-options'"
  >
    <!-- Explicit trigger to avoid [object Object] -->
    <mat-select-trigger class="language-selected-value">
      <span>
        {{
          (formControl?.value?.[displayKey])
            || (optionType === 'primitive' ? formControl?.value : '')
        }}
      </span>
      <nuc-icon iconClass="stla-dropdown" size="32"></nuc-icon>
    </mat-select-trigger>

    @if(optionType != 'object') {
      <mat-option *ngFor="let option of options" [value]="option">
        {{ option }}
      </mat-option>
    } @else {
      <mat-option
        *ngFor="let option of options; trackBy: trackByKey ? trackByFunction : null"
        [value]="option" class="language-code-bold"
      >
        {{ option[displayKey] | uppercase}}
      </mat-option>
    }
  </mat-select>

   <!-- <mat-select [panelClass]="'language-switcher-options'" [(value)]="selectedLanguage" name="language"
    (selectionChange)="onLanguageSelectionChange($event)">
    <mat-select-trigger class="language-selected-value">
      <span>{{ selectedLanguage?.languageCode?.toUpperCase()}} </span>
    </mat-select-trigger>

    <mat-option *ngFor="let lang of languages; trackBy: trackLanguagesBy" [value]="lang">
      <span>{{ lang.countryCode }}</span> <span class="language-code-bold">{{ lang.languageCode.toUpperCase() }}</span>
    </mat-option>
  </mat-select> -->
  <mat-error *ngIf="formControl?.invalid">{{ errorMessage }}</mat-error>
</mat-form-field>
}
@else{
<mat-form-field appearance="outline" class="{{displayClass}}">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select [panelClass]="'language-switcher-options'" [(value)]="selectedLanguage" name="language"
    (selectionChange)="onLanguageSelectionChange($event)">
    <mat-select-trigger class="language-selected-value">
      <span>{{ selectedLanguage?.languageCode?.toUpperCase()}} </span>
      <nuc-icon iconClass="stla-dropdown" size="32"></nuc-icon>
    </mat-select-trigger>

    <mat-option *ngFor="let lang of languages; trackBy: trackLanguagesBy" [value]="lang">
      <span>{{ lang.countryCode }}</span> <span class="language-code-bold">{{ lang.languageCode.toUpperCase() }}</span>
    </mat-option>
  </mat-select>
</mat-form-field>
}
